export { default } from './MapCreateSpotRain';
